// import { ICourseDay } from "../../../modules/orders/type/addOrder";

export const STATIC_COURSE_DAYS: ReadonlyArray<any> = [
  { days: [3, 5, 7], title: "evenDays" },
  { days: [2, 4, 6], title: "oddDays" },
];

export const DAYS_OF_WEEK = [
  {
    value: 1,
    label: "sunday",
  },
  {
    value: 2,
    label: "monday",
  },
  {
    value: 3,
    label: "tuesday",
  },
  {
    value: 4,
    label: "wednesday",
  },
  {
    value: 5,
    label: "thursday",
  },
  {
    value: 6,
    label: "friday",
  },
  {
    value: 7,
    label: "saturday",
  },
];
